import { getConfig } from '@components/Config';
import { useAppContext } from '@components/AppContext';
import { type AppContext } from '@components/AppContext/types';

type Organization = {
  id: string;
  name: string;
  isDisabled?: boolean;
};

const consoleOrganizationId = getConfig('consoleOrganizationId');

const useOrganizations = (): Organization[] => {
  const { identity } = useAppContext() as AppContext;
  const organizations = identity?.organizations || [];

  const noConsoleOrganizations = organizations
    .filter(({ id }: Organization) => id !== consoleOrganizationId)
    .filter(({ isDisabled }: Organization) => !isDisabled);

  const sortedOrganizations = noConsoleOrganizations.sort(
    (organizationA: Organization, organizationB: Organization) => (
      organizationA.name.localeCompare(organizationB.name)
    ),
  );

  return sortedOrganizations;
};

export default useOrganizations;
